export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11664.cf009176.jpg";